<script lang="ts">
	import type { HelpPalletsProps } from "./HelpPalletsProps.js";
	import HelpPage from "../components/HelpPage.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import helpCrates from "../assets/images/crates.png";

	type $$Props = HelpPalletsProps;

	const { references, products, categories, blogPosts } = $$restProps as $$Props;

	setContext(thumbnailImageContextKey, helpCrates);
</script>

<HelpPage
	heading="Chci skladovat v přepravkách"
	perex="V sortimentu najdete EURO přepravky, vkládací přepravky, které šetří místo při skladování prázdných boxů, skládací boxy pro maximální flexibilitu, a také boxy s odebíracím otvorem, které usnadňují přístup k obsahu. Naše přepravky jsou ideální pro využití s regálovými systémy a pomohou vám efektivně uspořádat skladové prostory."
	{references}
	{products}
	{categories}
	{blogPosts}
>
	<p slot="subHeading">
		{nbspify("Pro skladování nabízíme širokou škálu našich")}
		<span class="text-primary">{nbspify("přepravek a boxů,")}</span>
		{nbspify("které jsou navrženy tak, aby splňovaly veškeré logistické požadavky.")}
	</p>
</HelpPage>
